import styled , {css} from 'styled-components'

export const FlexCenter = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ContainerBlock = styled.div<any>`
  width: 100%;
  max-width: 1464px;
  margin: 0 auto;
  padding: 0 32px;

  &.-min-height {
    min-height: 50vh;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ${({ big }) =>
    big &&
    css`
      max-width: 1464px;
    `}
    
  @media screen and (max-width: 1160px) {
    max-width: 1032px;
    padding: 0 24px;
  }
  @media screen and (max-width: 740px) {
    padding: 0 16px;
  }
`;
